var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcShareIOs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.714 2.55a1 1 0 0 0-1.421-.007l-3.5 3.5a1 1 0 0 0 1.414 1.414L11 5.664v8.96a1 1 0 1 0 2 0v-8.96l1.793 1.793a1 1 0 1 0 1.414-1.414zM5 11a1 1 0 0 1 1 1v7a.75.75 0 0 0 .75.75h10.5A.75.75 0 0 0 18 19v-7a1 1 0 1 1 2 0v7a2.75 2.75 0 0 1-2.75 2.75H6.75A2.75 2.75 0 0 1 4 19v-7a1 1 0 0 1 1-1",
  clipRule: "evenodd"
})));
export default SvgIcShareIOs;